
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class LiveWidgetDOMAPI
 * @hideconstructor
 * @classdesc API class that is used to get a JSON representation of the the UI of the widget
 */
define([], () => {
	class LiveWidgetDOMAPI {

		/**
		 * @function LiveWidgetDOMAPI#getUIJSON
		 * @description get a JSON representation of the the UI of widget
		 * @returns {Object} UIJSON A JSON representation of the UI of the widget
		 * @returns {array} UIJSON.widgetIcons Array of objects containing the label of the visible widget icons displayed. Visible icons which do not have a matching aria-label and title will return a null label. Otherwise, returns undefined.
		 * @returns {object} UIJSON.title Title object containing: value, fontSize, fontFamily, and alignment. Returns undefined if the title is not displayed.
		 */
		getUIJSON() {}

		/**
		 * @function LiveWidgetDOMAPI#registerProvider
		 * @description Register a provider as a LiveWidgetDOMAPI UIJSON provider
		 * @param {provider} provider LiveWidgetDOMAPI provider to register and contribute to UIJSON
		 */
		registerProvider() {}
	}

	return LiveWidgetDOMAPI;
});
